import React from 'react';

const TrainIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(8.000000, 7.000000)'>
        <path d='M8,0 C4,0 0,0.5 0,4 L0,13.5 C0,15.4329966 1.56700338,17 3.5,17 L2,18.5 L2,19 L4.23,19 L6.23,17 L10,17 L12,19 L14,19 L14,18.5 L12.5,17 C14.4329966,17 16,15.4329966 16,13.5 L16,4 C16,0.5 12.42,0 8,0 M3.5,15 C2.67157288,15 2,14.3284271 2,13.5 C2,12.6715729 2.67157288,12 3.5,12 C4.32842712,12 5,12.6715729 5,13.5 C5,14.3284271 4.32842712,15 3.5,15 M7,8 L2,8 L2,4 L7,4 L7,8 M9,8 L9,4 L14,4 L14,8 L9,8 M12.5,15 C11.6715729,15 11,14.3284271 11,13.5 C11,12.6715729 11.6715729,12 12.5,12 C13.3284271,12 14,12.6715729 14,13.5 C14,14.3284271 13.3284271,15 12.5,15 Z' />
      </g>
    </g>
  </svg>
);

export default TrainIcon;
